import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  bgColor?: string;
}

export const Wrapper = styled.p`
  background: ${(props: Props) => props.bgColor};
  border-radius: 4px;
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
  font-weight: 600;
  padding: 0 9px;
  cursor: pointer;
  display: flex;
  line-height: 24px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Igv = styled.span`
  font-size: 10px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;

export const Price = styled.span`
  margin-left: auto;
`;
